import { INavigationItem } from '@engineering11/ui-lib/e11-nav-left'

export type NavTourAnchorItem = Pick<Partial<INavigationItem>, 'route' | 'name'> & { tourId?: string }

/**
 * Stable `[data-tour-id]` slug for a nav row. Prefers an explicit `tourId` (so the curated top-level
 * anchors — nav-openings, nav-engage, … — keep working unchanged); otherwise derives a slug from the
 * row's `route` (a string, or an array joined by `-`), falling back to its `name`. The result is
 * lowercased with every run of non-alphanumeric characters collapsed to a single `-` and trimmed.
 */
export function navTourAnchor(item: NavTourAnchorItem): string {
  if (item.tourId) return item.tourId
  const route = item.route
  const source =
    typeof route === 'string' && route.length > 0
      ? route
      : Array.isArray(route) && route.length > 0
      ? route.map(seg => String(seg)).join('-')
      : item.name ?? ''
  return source
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
